import React from 'react';
import { HomeHero } from '../components/home/HomeHero';
import { HomeSolutions } from '../components/home/HomeSolutions';
import { HomeActionExamples } from '../components/home/HomeActionExamples';
import { HomeFoundations } from '../components/home/HomeFoundations';
import { HomeResearch } from '../components/home/HomeResearch';
import { HomeInitiatives } from '../components/home/HomeInitiatives';
import { HomeCTA } from '../components/home/HomeCTA';
export function HomePage() {
  return <>
      <HomeHero data-id="element-2867" data-mp="2s1xrvyur5k0l" />
      <HomeSolutions data-id="element-2868" data-mp="2s2h4d01mvg78" />
      <HomeActionExamples data-id="element-2869" data-mp="2s38ys7jhv7vx" />
      <HomeFoundations data-id="element-2870" data-mp="36qbuc8o9b6gm" />
      <HomeResearch data-id="element-2871" data-mp="36qu1w1gdd73u" />
      <HomeInitiatives data-id="element-2872" data-mp="36r3rhnxi5c90" />
      <HomeCTA data-id="element-2873" data-mp="36rmywapj0i8s" />
    </>;
}